import { Injectable } from '@angular/core';
import { DateTimeFormatterFormatType, LocaleService } from './locale';


@Injectable({
    providedIn: 'root',
})
export class DateTimeFormatter {
    constructor(private localeService: LocaleService) {}

    format(date: Date, format: DateTimeFormatterFormatType): string {
        return this.localeService.format(date, format);
    }
}
